import React from 'react'
import style from "./Sheet.module.css";
import { comma } from "../../utils/utils";

const Debt = ({index, key_name, handleInput, data}) => {

  return (
    <div className={style.add_txt}>
      <div className={style.item_input_text}>
        <p className={style.tit}>채무의 표시</p>
        <input type="text" name={`${key_name}_kind`} data-index={index} placeholder='기업은행 마이너스 통장' value={data?.kind} onChange={handleInput}/>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>채무의 가액(원)</p>
        <input type="text" name={`${key_name}_amount`} data-index={index} placeholder='10,000,000 (숫자만 입력)' value={comma(data?.amount)} onChange={handleInput}/>
      </div>
    </div>
  )
}

export default Debt